import { render, staticRenderFns } from "./Calificacion.vue?vue&type=template&id=12cece89"
import script from "./Calificacion.vue?vue&type=script&lang=js"
export * from "./Calificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports